// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1SM6hNernmSbLv7CA3FWw9"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/TooltipItem.scss
// module id = 1572
// module chunks = 0